import React from 'react'

import CollapsibleContent from '@/components/misc/CollapsibleContent'
import SectionHeading from '@/components/misc/CompanyProfile/tabs/OverviewTab/SectionHeading'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  briefHistory?: string
}

const BriefHistory: React.FC<Props> = ({ briefHistory, ...props }) => {
  if (!briefHistory) {
    return null
  }

  return (
    <div {...props}>
      <SectionHeading>Brief history</SectionHeading>
      <CollapsibleContent content={briefHistory} allowHtml />
    </div>
  )
}

export default BriefHistory
